import { render, staticRenderFns } from "./SampleReadyToMakeBody.vue?vue&type=template&id=787799ed&"
import script from "./SampleReadyToMakeBody.vue?vue&type=script&lang=js&"
export * from "./SampleReadyToMakeBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports